import { TableBody, TableCell, TableRow } from '@mui/material';
import {
  FooterCell,
  FooterContainer,
  HeaderCell,
  StyledHeader,
  StyledRow,
  StyledTable,
} from 'components/TableComponents/TableComponents';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { numberToCurrencyString } from 'further-ui/utils';
import { HoldingClassRealisations } from '../EnterConsideration/ManualConsiderationForm/types';
import { round } from 'lodash';

type Props = {
  currency: CurrencyCode;
  holdingClassRealisations: HoldingClassRealisations;
};

const CashConsiderationsTable: React.FC<Props> = ({
  currency,
  holdingClassRealisations,
}) => {
  return (
    <StyledTable
      hasBorderTopLeftRadius
      hasBorderBottomLeftRadius
      hasBorderTopRightRadius
      hasBorderBottomRightRadius
      hasMinWidth={false}
    >
      <StyledHeader>
        <StyledRow>
          <HeaderCell
            colSpan={holdingClassRealisations.length + 1}
            align="center"
            isHeader
            backgroundColor="dark"
            textSize="regular"
            paddingSize="md"
          >
            Cash consideration (and withholding tax)
          </HeaderCell>
        </StyledRow>
      </StyledHeader>
      <StyledHeader>
        <StyledRow>
          <HeaderCell backgroundColor="paper">&nbsp;</HeaderCell>
          {holdingClassRealisations.map((holdingClassRealisation) => (
            <HeaderCell
              key={holdingClassRealisation.holdingClassId}
              backgroundColor="paper"
            >
              {holdingClassRealisation.name}
            </HeaderCell>
          ))}
        </StyledRow>
      </StyledHeader>
      <TableBody>
        <StyledRow>
          <TableCell>Cash received value</TableCell>
          {holdingClassRealisations.map((holdingClassRealisation) => (
            <TableCell key={holdingClassRealisation.holdingClassId}>
              {numberToCurrencyString(
                holdingClassRealisation.cashConsiderationAmounts
                  ?.receivedConsiderationTotal || 0,
                { currency, unlimitedDp: true },
              )}
            </TableCell>
          ))}
        </StyledRow>
        <StyledRow>
          <TableCell>Cash escrow value</TableCell>
          {holdingClassRealisations.map((holdingClassRealisation) => (
            <TableCell key={holdingClassRealisation.holdingClassId}>
              {numberToCurrencyString(
                holdingClassRealisation.cashConsiderationAmounts
                  ?.escrowConsiderationTotal || 0,
                { currency, unlimitedDp: true },
              )}
            </TableCell>
          ))}
        </StyledRow>
        <StyledRow>
          <TableCell>Cash earnout value</TableCell>
          {holdingClassRealisations.map((holdingClassRealisation) => (
            <TableCell key={holdingClassRealisation.holdingClassId}>
              {numberToCurrencyString(
                holdingClassRealisation.cashConsiderationAmounts
                  ?.earnoutConsiderationTotal || 0,
                { currency, unlimitedDp: true },
              )}
            </TableCell>
          ))}
        </StyledRow>
        <StyledRow>
          <TableCell>Withholding tax payable</TableCell>
          {holdingClassRealisations.map((holdingClassRealisation) => (
            <TableCell key={holdingClassRealisation.holdingClassId}>
              {numberToCurrencyString(
                holdingClassRealisation.cashConsiderationAmounts
                  ?.withholdingTaxPayable || 0,
                { currency, unlimitedDp: true },
              )}
            </TableCell>
          ))}
        </StyledRow>
      </TableBody>
      <FooterContainer>
        <TableRow>
          <FooterCell colSpan={1} paddingSize="sm">
            Total cash consideration value
          </FooterCell>
          {holdingClassRealisations.map((holdingClassRealisation) => (
            <FooterCell
              key={holdingClassRealisation.holdingClassId}
              colSpan={1}
              paddingSize="sm"
            >
              {numberToCurrencyString(
                round(
                  (holdingClassRealisation.cashConsiderationAmounts
                    ?.receivedConsiderationTotal || 0) +
                    (holdingClassRealisation.cashConsiderationAmounts
                      ?.escrowConsiderationTotal || 0) +
                    (holdingClassRealisation.cashConsiderationAmounts
                      ?.earnoutConsiderationTotal || 0) +
                    (holdingClassRealisation.cashConsiderationAmounts
                      ?.withholdingTaxPayable || 0),
                  3,
                ),
                { currency, unlimitedDp: true },
              )}
            </FooterCell>
          ))}
        </TableRow>
      </FooterContainer>
    </StyledTable>
  );
};

export default CashConsiderationsTable;
